module.exports = __webpack_public_path__ + "img/car-3.55f55bf7.jpg";